import {Button as MuiButton} from 'react-bootstrap';
import {ButtonProps} from '@mui/material/Button';
import React, {memo, ReactNode} from 'react';

import useTranslate from 'hooks/useTranslate';

interface CustomButtonProps {
  label: string;
  color?: ButtonProps['color'];
  isDisabled?: boolean;
  icon?: boolean;
  onClick?: () => void;
  startIcon?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  variant?: string;
}

const Button: React.FC<CustomButtonProps> = ({
  color = 'primary',
  isDisabled = false,
  onClick,
  label,
  startIcon,
  type = 'button',
  variant = 'contained',
  ...props
}) => {
  const {parseUI} = useTranslate();

  return (
    <MuiButton
      style={{fontFamily: 'Gotham'}}
      disabled={isDisabled}
      variant={variant}
      icon={startIcon}
      color={color}
      onClick={onClick}
      {...props}>
      {parseUI(label)}
    </MuiButton>
  );
};

export default memo(Button);
